import { IProfile } from '@jumpstart/core';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { JSONInputEvent } from './json-input';


export interface IProfileJson {
  subscriberProfile: IProfile;

  onSubmit(profile: IProfile): void;
}

export default function ProfileJson(props: IProfileJson) {
  const { subscriberProfile, onSubmit } = props;
  const [newProfile, setNewProfile] = useState<null | IProfile>(null);

  const handleChange = (event: JSONInputEvent) => {
    if (event.error) {
      console.error(event.error);
      setNewProfile(null);
    } else if (event.jsObject) {
      setNewProfile(event.jsObject);
    }
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      sx={{
        '& > :not(:last-child)': {
          marginBottom: 4
        }
      }}
    >
      <Grid item>

        <JSONInput
          id={subscriberProfile.id}
          placeholder={subscriberProfile}
          // colors      = { darktheme }
          locale={locale}
          height='380px'
          onChange={handleChange}
        />
      </Grid>
      <Button
        variant="contained"
        size="large"
        disabled={!newProfile}
        onClick={() => {
          if (newProfile) {
            onSubmit(newProfile);
          }
        }}
      >
        Submit
      </Button>
    </Grid>
  );
}
